import { SdbMemberTypes } from "@custom-types/member-types";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store/store-helper";
import { activeMembersAdapter } from "@store/active-members/active-members-slice";
import { ActiveMembersState } from "@store/active-members/active-members-slice-helper";

/**
 * Returns all the stored active members.
 */
export const activeMembersSelector: (state: RootState) => SdbMemberTypes[] =
  createSelector(
    (state: RootState) => state.activeMembers,
    (activeMembers) => {
      return activeMembersAdapter.getSelectors().selectAll(activeMembers);
    }
  );

/**
 * Returns the fetching properties of the active members slice.
 */
export const fetchingActiveMembersFlagsSelector: (
  state: RootState
) => ActiveMembersState["fetching"] = createSelector(
  (state: RootState) => state.activeMembers,
  (activeMembers) => {
    return activeMembers.fetching;
  }
);
